export class State
{
id:number; 
statevalue : string; 
}